// extracted by mini-css-extract-plugin
module.exports = {"image":"full_image__WZN4A"};